module.exports = __webpack_public_path__ + "static/img/cadillac_1.7ee412b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/cadillac_1.png
// module id = acLG
// module chunks = 213